
import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
// import { useReactToPrint } from "react-to-print";
import { ArrowLeft, Download, FileDown, Mail, MoveLeft, Play, Printer, PrinterCheck, Search, Settings } from 'lucide-react';
import classes from "./SavingsBalance.module.css"
import RotatingLogo from '../../Assets/Promix.svg'
import BackLogo from '../../Assets/assets/back.svg'
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { Spinner, Badge, Button, Modal, Form } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useLocation, useNavigate } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Swal from "sweetalert2";
import api, { BASE_URL } from "../../Components/API/Api";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";











const SavingsBalance = () => {
  const location = useLocation();
  const receiptRef = useRef(null);
  const [savings, setSavings] = useState([]);
const [noData, setNoData] = useState(false);
const [savingsTypeLoading, setSavingsTypeLoading] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [bearer, setBearer] = useState('');
  const [savingsLoading, setSavingsLoading] = useState(false);
  const navigate = useNavigate();
  const [savingsId, setSavingsId] = useState("");
  const [selectedProductId, setSelectedProductId] = useState("");
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [selectedProducts, setSelectedProducts] = useState([]);

  const readData = async () => {
    try {
      const value = await localStorage.getItem('authToken');
     

      if (value !== null) {
        setBearer(value);
      }
    
    } catch (e) {
      alert('Failed to fetch the input from storage');
    }
  };

  useEffect(() => {
    readData();
  }, []);

  const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };


const [summary, setSummary] = useState([]);


 const fetchReports = async () => {
  setSavingsLoading(true);
  try {
    const companyId = localStorage.getItem("company_id") || localStorage.getItem("companyId");
    
    const response = await api.get(`/v1/member_balance_by_savings`, {
      params: {
    company_id: companyId,
    savings_id: savingsId,

      },
      headers: {
        'Content-Type': 'application/json'
       
      }
    });

  

    const filtData1 = response.data?.data?.members || [];
    const filtData2 = response.data?.data?.summary || [];
   

    if (filtData1.length === 0) {
      Swal.fire({
        icon: 'error',
        title: 'No Data Found',
        text: 'No data to be displayed.',
      });
      
    } else {
      
      setAccounts(filtData1);
      setSummary(filtData2);
      

    }
    

  } catch (error) {
    if (error.response && error.response.status === 401) {
      navigate('/login');
    } else {
      console.log(error);
      setAccounts([]);   // ✅ also clear here on error
      setNoData(true);
    }
  } finally {
    setSavingsLoading(false);
  }
};

  useEffect(() => {
    const fetchSavingsTypes = async () => {
      setSavingsTypeLoading(true);
      try {
        const token = localStorage.getItem("authToken");
        const res = await api.get('/v1/savings_product', 
          { 
            // params: { name: 'payment' } 
        }
      );
        if (res.data && Array.isArray(res.data.data)) {
          setSavings(res.data.data);
        } else {
          setSavings([]);
        }
      } catch (err) {
        setSavings([]);
      } finally {
        setSavingsTypeLoading(false);
      }
    };
    fetchSavingsTypes();
  }, []);





const tableRef = useRef(null);
const userData = JSON.parse(localStorage.getItem('userData'));

const printReport = () => {
  const printContents = receiptRef.current.innerHTML;

  const printWindow = window.open("", "_blank", "width=1200,height=900");

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Members' Savings Balance Report</title>

        <style>

          body{
              font-family: Arial, sans-serif;
              margin:20px;
              color:#000;
          }

          h1{
              text-align:center;
              margin-bottom:5px;
          }

          p{
              text-align:center;
              margin-top:0;
              margin-bottom:25px;
          }

          table{
              width:100%;
              border-collapse:collapse;
          }

          th,td{
              border:1px solid #ddd;
              padding:8px;
              font-size:12px;
              text-align:left;
          }

          th{
              background:#f3f4f6;
              color:#000;
              font-weight:bold;
          }

          tr{
              page-break-inside:avoid;
          }

          @page{
              margin:10mm;
          }

        </style>

      </head>

      <body>

      ${printContents}

      </body>

    </html>
  `);

  printWindow.document.close();

  printWindow.focus();

  setTimeout(() => {
    printWindow.print();
    printWindow.close();
  }, 500);
};

const downloadExcel = () => {
  if (accounts.length === 0) {
    Swal.fire({
      icon: "warning",
      title: "No Data",
      text: "There is no data to export.",
    });
    return;
  }

  const excelData = accounts.map((acc, index) => ({
    "S/N": index + 1,
    "Member Name": acc.name,
    "Savings (₦)": Number(acc.total_savings),
    "Withdrawals (₦)": Number(acc.total_withdrawals),
    "Balance (₦)": Number(acc.balance),
  }));

  // Add summary row
  excelData.push({});
  excelData.push({
    "S/N": "",
    "Member Name": "SUMMARY",
    "Loan (₦)": Number(summary?.total_loan || 0),
    "Repayments (₦)": Number(summary?.total_paid_loan || 0),
    "Balance (₦)": Number(summary?.balance || 0),
  });

  const worksheet = XLSX.utils.json_to_sheet(excelData);

  // Set column widths
  worksheet["!cols"] = [
    { wch: 8 },   // S/N
    { wch: 40 },  // Member Name
    { wch: 18 },  // Savings
    { wch: 18 },  // Withdrawals
    { wch: 18 },  // Balance
  ];

  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "Savings Balance Report"
  );

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const data = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });

  saveAs(
    data,
    `Members_Savings_Balance_Report_${new Date()
      .toISOString()
      .slice(0, 10)}.xlsx`
  );
};


  return (
    <div style={{ backgroundColor: "#f9f9f9", minHeight: "100vh" }}>
      <HeaderNav />

      <div className={classes.topContainer}>
        <div className={classes.backTxt}>
          {/* <MoveLeft className={classes.iconBtn} onClick={() => navigate(-1)} /> */}
          <img src={BackLogo} alt="back" className={classes.iconBtn} onClick={() => console.log("icon3")} />
          <div className={classes.bckText}>
            <h3 className={classes.topText}>Members' Savings Balance Report </h3>
            
          </div>
          
        </div>
         <div className={classes.Group3} style={{marginTop: '32px'}}>
          <div>
            <label>Savings Account</label>
              <div className={classes.searchableDropdown}>
        <select
  value={selectedProductId}
  onChange={(e) => {
    const productId = Number(e.target.value);

    const selectedItem = savings.find(
      (item) => item.id === productId
    );

    if (!selectedItem) return;

    setSelectedProductId(productId);
    setSelectedCompanyId(selectedItem.company_id);
    setSavingsId(selectedItem.id);

    setSelectedProducts((prev) => {
      const exists = prev.some(
        (product) => product.id === selectedItem.id
      );

      if (exists) return prev;

      return [...prev, selectedItem];
    });
  }}
>
  <option value="">Select Savings Product</option>

  {savingsTypeLoading ? (
    <option disabled>Loading savings products...</option>
  ) : (
    savings.map((product) => (
      <option
        key={product.id}
        value={product.id}
      >
        {product.product_name}
      </option>
    ))
  )}
</select>

                
          </div>
          </div>
         
          <button disabled={!savingsId || savingsLoading} className={classes.loanBtn} onClick={fetchReports}> <Play size={14} color="#fff"/> Run Report </button>
         
          </div>
      
        <div style={{ marginTop: 24 }} />
       
        <div  className={classes.tableContainer}>
         
         {accounts.length === 0 ? (
             <div
               style={{
                 textAlign: "center",
                 padding: "40px",
                 fontSize: "18px",
                 color: "#374151",
               }}
             >
               <p>No data to display</p>
             </div>
           ) : (
             <>
               <div className={classes.sideTools}>
                 {accounts.length > 0 && (
                   <div className={classes.filterIcons}>
                     <Mail
                       className={classes.iconBtns}
                       onClick={() => console.log("icon1")}
                     />
                     <PrinterCheck 
                      onClick={printReport}
                      //  onClick={() => window.print()}
                       className={classes.iconBtns}
                     />
                    <FileDown 
                       className={classes.iconBtns}
                       onClick={() => downloadExcel ()}
                     />
                   </div>
                 )}
               </div>
             <div ref={receiptRef} style={{
    // padding: "40px",
    background: "#ffffff",
  }}>
          <div className={classes.cntrTable} >
            <h1 className={classes.cntrTxt}>{userData?.company?.name}</h1>
              <p className={classes.cntrTx122} style={{marginBottom: "40px"}} >Members' Savings Balance Report
                       - {""} {new Date().toLocaleDateString()}
    
                     </p>
           

          </div>
 <table style={{ width: "100%", borderCollapse: "collapse", margin: 'auto' }}>
          <thead>
           
         
            <tr style={{borderBottom: "1px solid #d1d5db",}}>
      <th style={{ textAlign: 'left', fontSize: 12}}>S/N</th>
      {/* <th style={{ textAlign: 'left', fontSize: 12}}>Reg. No.</th> */}
      <th style={{ textAlign: 'left', fontSize: 12}}>Member Name</th>
      <th style={{ textAlign: 'right', fontSize: 12}}>Savings (₦)</th>
      <th style={{ textAlign: 'right', fontSize: 12}}>Withdrawals (₦)</th>
      <th style={{ textAlign: 'right', fontSize: 12}}>Balance (₦)</th>
    </tr>
          </thead>
         <tbody>
  {accounts?.map((acc, index) => (
    <tr key={index} style={{ borderBottom: "1px solid #d1d5db", }}>
      
      {/* Bank Name */}
      <td style={{ fontSize: 13, padding: 5 }}>
        {index + 1}
      </td>
      {/* <td style={{ fontSize: 13, padding: 5 }}>
        {acc.member_number}
      </td> */}
      <td style={{ fontSize: 13, padding: 5, width: 400 }}>
        {acc.name}
      </td>
      <td style={{ fontSize: 13, padding: 5,  textAlign: 'right' }}>
        {Number(acc.total_savings).toLocaleString('en-NG', { minimumFractionDigits: 2 })}
      </td>
      <td style={{ fontSize: 13, padding: 5, textAlign: 'right' }}>
        {Number(acc.total_withdrawals).toLocaleString('en-NG', { minimumFractionDigits: 2 })}
      </td>
      <td style={{ fontSize: 13, padding: 5, textAlign: 'right' }}>
        {Number(acc.balance).toLocaleString('en-NG', { minimumFractionDigits: 2 })}
      </td>
    </tr>
  ))}
</tbody>


        </table>
        <div
  // style={{
  //   marginTop: 25,
  //   width: "40%",
  //   marginLeft: "auto",
  //   border: "1px solid #d1d5db",
  //   borderRadius: 6,
  //   overflow: "hidden",
  // }}
  className={classes.summaryContainer}
>
  <div
    style={{
      background: "#f5f5f5",
      padding: "10px 15px",
      fontWeight: "bold",
      fontSize: 14,
      borderBottom: "1px solid #d1d5db",
    }}
  >
    Summary:-
  </div>

  <div style={{ padding: 15 }}>
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginBottom: 10,
        fontSize: 13,
      }}
    >
      <span>Total Savings</span>
      <strong>
        ₦{Number(summary?.total_savings || 0).toLocaleString("en-NG", {
          minimumFractionDigits: 2,
        })}
      </strong>
    </div>

    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        marginBottom: 10,
        fontSize: 13,
      }}
    >
      <span>Total Withdrawals</span>
      <strong>
        ₦{Number(summary?.total_saving_withdrawal || 0).toLocaleString("en-NG", {
          minimumFractionDigits: 2,
        })}
      </strong>
    </div>

    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        fontSize: 13,
        fontWeight: "bold",
        borderTop: "1px solid #d1d5db",
        paddingTop: 10,
      }}
    >
      <span>Total Balance</span>
      <strong>
        ₦{Number(summary?.balance || 0).toLocaleString("en-NG", {
          minimumFractionDigits: 2,
        })}
      </strong>
    </div>
  </div>
</div>
         </div>

         


 </>
  )}
 
        </div>
     <div style={{ marginTop: 27 }} />
 
      </div>
      {savingsLoading && (
                  <div className={classes.overlay}>
                    <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
                  </div>
                )}

    </div>
  )
}

export default SavingsBalance
